/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Step3_TitleInputs */

const es_landing_step3_title = /** @type {(inputs: Landing_Step3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tramitamos el cambio de uso`)
};

const gl_landing_step3_title = /** @type {(inputs: Landing_Step3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tramitamos o cambio de uso`)
};

const en_landing_step3_title = /** @type {(inputs: Landing_Step3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We process the change of use`)
};

/**
* | output |
* | --- |
* | "We process the change of use" |
*
* @param {Landing_Step3_TitleInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const landing_step3_title = /** @type {((inputs?: Landing_Step3_TitleInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Step3_TitleInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_landing_step3_title(inputs)
	if (locale === "en") return en_landing_step3_title(inputs)
	return es_landing_step3_title(inputs)
});